function n(n={}){const r=new AbortController;return import("./renderVisualEditing.js").then((({renderVisualEditing:t})=>{const{signal:e}=r;e.aborted||t(e,n)})),()=>{r.abort()}}export{n as e};//# sourceMappingURL=enableVisualEditing.js.map
